// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ABgog","title":"styles_title__oNQTX","subTitle":"styles_subTitle__DTSUv","BackBtn":"styles_BackBtn__B5T9q"};